import React, { useEffect, useState } from 'react'
import { UseStateValue } from "./Stateprovider"
import { Link, useNavigate } from 'react-router-dom'
import CheckoutProducts from './CheckoutProduct'
import "./Payment.css"
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js'
import CurrencyFormat from 'react-currency-format'
import axios from "./axios"
import { db } from './Firebase'
function Payment() {
    const [{basket, user}, dispatch]=UseStateValue()
    const navigate = useNavigate()
    const getBasketTotal = (basket) =>
    basket?.reduce((amount, item) => item.price + amount, 0);
    const stripe =  useStripe()
    const Elements = useElements()

    const [error, seterror]=useState(null)
    const[disabled, setdisabled] =useState(true)

    const[succeeded, setsucceeded] =useState(false)
    const[processing, setprocessing] = useState(false)
    const[clientSecret, setClientSecret] = useState("")
    useEffect(() => {
        const getClientSecret = async () => {
          const amount = getBasketTotal(basket) * 100;
    
          const response = await axios({
            method: "post",
            url: `/payments/create?total=${amount}`,
          });
          setClientSecret(response.data.clientSecret);
        };
        getClientSecret();
      }, [basket]);
    console.log("The secret is >>>", clientSecret);

    const handleSubmit = async(e)=>{
        e.preventDefault();
        setprocessing(true);
        await stripe.confirmCardPayment(clientSecret, {
            payment_method:{
                card: Elements.getElement(CardElement),
            },
        }).then(({paymentIntent})=>{
            db.collection("users")
          .doc(user?.uid)
          .collection("orders")
          .doc(paymentIntent.id)
          .set({
            basket: basket,
            amount: paymentIntent.amount,
            created: paymentIntent.created,
          });
            setsucceeded(true);
            seterror(null);
            setprocessing(false);
            
            dispatch({
                type: "EMPTY_BASKET",
            });
            navigate("/orders");
        });
    };
    const handleChange = (event)=>{
        setdisabled(event.empty);
        seterror(event.error?event.error.message: null);
    }
  return (
    <div className='payment'>
     <div className='payment_container'>
     <h1>
        checkout(<Link to={"/checkout"}>{basket?.length} items</Link>)
     </h1>
     <div className='payment_section'>
        <div className='payment_title'>
            <h3>Delivery Address</h3>
        </div>
        <div className='payment_address'>
            <p>{user?.email}</p>
            <p>Philadelphia</p>
            <p>Philadelphia PA</p>
        </div>
     </div>
     <div className='payment_section'>
        <div className='payment_title'>
        <h3>Review items and delivery</h3>
        </div>
        <div className='payment_items'>
            {basket.map((item)=>(
                <CheckoutProducts
                id={item.id}
                title={item.title}
                image={item.image}
                price={item.price}
                rating={item.rating}
                />
                ))}
        </div>
     </div>
     <div className='payment_section'>
        <div className='payment_title'>
            <h3>payment method</h3>
        </div>
        <div className='payment_detail'>
            <form onSubmit={handleSubmit}>
                <CardElement onChange={handleChange}/>
                <div className='payment_priceContainer'>
                    <CurrencyFormat
                    renderText={(value)=><h3>Order Total:{value}</h3>}
                    decimalScale={2}
                    value={getBasketTotal(basket)}
                    displayType='text'
                    thousandSeparator={true}
                    prefix='$'
                    />
                    <button disabled={processing || disabled || succeeded}>
                        <span>{processing?<p>processing</p>: "Buy Now"}</span>
                    </button>

                </div>
                {error && <div>{error}</div>}
            </form>
        </div>
     </div>
     </div>
    </div>
  )
}

export default Payment